import { IAppState } from '../../store';

export const selectReviewFormReviewId = (state: IAppState) => state.reviewForm.reviewId;
